/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S13_I1Inputs */

const tr_kullanim_s13_i1 = /** @type {(inputs: Kullanim_S13_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tacir veya tüzel kişi sıfatını haiz Kullanıcı da aboneliği herhangi bir zamanda, önceden haber verme süresine tabi olmaksızın Platform içi veya yazılı bildirimle iptal edebilir veya feshedebilir.`)
};

const en_kullanim_s13_i1 = /** @type {(inputs: Kullanim_S13_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A User qualifying as a merchant or legal entity may likewise cancel or terminate the subscription at any time and without any advance notice period, either in the Platform or by written notice.`)
};

const de_kullanim_s13_i1 = /** @type {(inputs: Kullanim_S13_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch der Nutzer mit Kaufmanns- oder juristischer Personeneigenschaft kann das Abonnement jederzeit und ohne Vorankündigungsfrist durch Mitteilung in der Plattform oder in Schriftform kündigen oder beenden.`)
};

const ru_kullanim_s13_i1 = /** @type {(inputs: Kullanim_S13_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь, имеющий статус коммерсанта или юридического лица, также может в любое время и без срока предварительного уведомления отменить или расторгнуть подписку через Платформу или письменным уведомлением.`)
};

/**
* | output |
* | --- |
* | "A User qualifying as a merchant or legal entity may likewise cancel or terminate the subscription at any time and without any advance notice period, either i..." |
*
* @param {Kullanim_S13_I1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s13_i1 = /** @type {((inputs?: Kullanim_S13_I1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S13_I1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s13_i1(inputs)
	if (locale === "de") return de_kullanim_s13_i1(inputs)
	if (locale === "ru") return ru_kullanim_s13_i1(inputs)
	return tr_kullanim_s13_i1(inputs)
});